<script>
  import bag from '@public/theme/mylly2023/assets/icon_bag.svg';
  import coffee from '@public/theme/mylly2023/assets/icon_coffee.svg';
  import disco from '@public/theme/mylly2023/assets/icon_disco.svg';
  import heart from '@public/theme/mylly2023/assets/icon_heart.svg';
  import movies from '@public/theme/mylly2023/assets/icon_movies.svg';
  import percentage from '@public/theme/mylly2023/assets/icon_percentage.svg';
  import present from '@public/theme/mylly2023/assets/icon_present.svg';
  import star from '@public/theme/mylly2023/assets/icon_star.svg';
  import starx5 from '@public/theme/mylly2023/assets/icon_starx5.svg';
  import turbines from '@public/theme/mylly2023/assets/icon_turbines.svg';

  const lookup = {
    bag,
    coffee,
    disco,
    heart,
    movies,
    percentage,
    present,
    star,
    starx5,
    turbines
  };

  export let icon_type = '';
  $: icon_src = lookup[icon_type]?.src;
</script>

<div class="title-icon {icon_type}" style="--icon: url('{icon_src}')" />

<style>
  .title-icon {
    position: relative;
    margin: 32px auto 16px;
    height: 96px;
    max-width: 160px;
    background-image: var(--icon);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  @media (min-width: 992px) {
    .title-icon {
      height: 100px;
      margin: 0 auto 16px;
    }
  }
</style>
